import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import getNodeEnv from './utils/getNodeEnv';
import { isString, trim } from 'lodash';
import countryNames from './country_names';

let isScrollLocked = false;

export const toggleScrollLock = function(
  replacementSelector,
  shouldLock = !isScrollLocked
) {
  // accepts a DOM node or a selector to be used
  const scrollTarget = replacementSelector.nodeType
    ? replacementSelector
    : document.querySelectorAll(replacementSelector)[0];
  if (scrollTarget) {
    if (shouldLock) {
      disableBodyScroll(scrollTarget);
    } else {
      enableBodyScroll(scrollTarget);
      // body-scroll-lock will set overflow: auto at this point
      // which breaks position: sticky for us, but is not reproducible in
      // a simple layout so it is limited to us
      document.body.style.overflow = null;
    }
  } else if (getNodeEnv() === 'development') {
    throw new Error(
      'toggleScrollLock was called without a replacement scrollable target'
    );
  }
  isScrollLocked = shouldLock;
};

// Removes whitespace from object values. Only for String values, to preserve nested objects and numbers
export const removeWhitespaceFromValues = data => {
  return Object.keys(data).reduce((map, key) => {
    map[key] = isString(data[key]) ? trim(data[key]) : data[key];
    return map;
  }, {});
};

export const base64DecodeUnicode = str => {
  return decodeURIComponent(
    atob(str)
      .split('')
      .map(c => {
        const tail = `00${c.charCodeAt(0).toString(16)}`.slice(-2);
        return `%${tail}`;
      })
      .join('')
  );
};

export const dateStringToDate = dateString => {
  // TODO use react-intl to account for international date formats.
  let [year, month, day] = dateString.split('-');
  year = parseInt(year, 10);
  month = parseInt(month, 10) - 1;
  day = parseInt(day, 10);

  return new Date(year, month, day);
};

export const getCountryFromStoreCode = storeCode => {
  const storeCodeISOMapping = {
    'juul-ca': 'CA',
    'juul-us': 'US',
    'juul-il': 'IL',
    'juul-uk': 'GB',
  };

  return storeCodeISOMapping[storeCode];
};

export const getCountryNameFromISO = iso => {
  const isoCountryNameMapping = {
    US: countryNames.COUNTRY_USA,
    IL: countryNames.COUNTRY_ISRAEL,
    GB: countryNames.COUNTRY_UK,
    CA: countryNames.COUNTRY_CANADA,
  };

  return isoCountryNameMapping[iso];
};

export const buildMeta = (
  { error = '', isLoading = false, receivedAt = Date.now() } = {}
) => ({
  error,
  isLoading,
  receivedAt,
});



// WEBPACK FOOTER //
// ./app/javascript/common/utils.js